import { Box, Divider } from '@mui/material';
import { SocialLinks } from '../../types/siteSetting';
import { FooterSocialIconSection } from './FooterSocialIconSection';
import { FooterMenuList } from './FooterMenuList';
import { FooterCopyrightContent } from './FooterCopyrightContent';
import { footerStyles } from './styles';
import { FooterLoadingComponent } from './FooterLoadingComponent';
import { MenuWithChildren } from '../../types/menu';

interface FooterProps {
  menus: MenuWithChildren[];
  isLoading?: boolean;
  socialLinks: SocialLinks;
}

export const Footer: React.FC<FooterProps> = ({ menus, isLoading = false, socialLinks }) => {
  return (
    <Box component="footer" className="container-fluid" sx={footerStyles.footer}>
      {isLoading ? (
        <FooterLoadingComponent />
      ) : (
        <>
          <FooterSocialIconSection socialLinks={socialLinks} />
          <FooterMenuList menus={menus} />
          <Divider sx={footerStyles.copyrightDivider} />
          <FooterCopyrightContent />
        </>
      )}
    </Box>
  );
};
